import { render, staticRenderFns } from "./StoreAdmin.vue?vue&type=template&id=18a9abb3&scoped=true&"
import script from "./StoreAdmin.vue?vue&type=script&lang=js&"
export * from "./StoreAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StoreAdmin.vue?vue&type=style&index=0&id=18a9abb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a9abb3",
  null
  
)

export default component.exports